import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearNoLocal } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";

const { DateTime } = require("luxon");

class AnalyticsTrackingRegister extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            startDate: this.props.startDate.startOf("day"),
            endDate: this.props.endDate.endOf("day"),
            startHour: 0,
            endHour: 23,
            minDate: "1753-01-01",
            maxDate: "9999-12-31",
            dateError: false,
            isLoading: false,
            clicks: [],
            selected: [],
            userSelected: this.props.location?.state?.["userName"]
                ? [{ userName: this.props.location.state["userName"] }]
                : [],
            options: [],
            userOptions: [],
            userValue: "",
            clicksLoading: false,
            ProfileClicksTable: {
                title: "Profile",
                options: {
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'date',
                        direction: 'desc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        this.getClicks();
    };

    componentDidUpdate = async (prevProps, prevState) => {
        // Only run validation if dates changed
        if (
            prevProps.startDate !== this.props.startDate ||
            prevProps.endDate !== this.props.endDate ||
            prevProps.userId !== this.props.userId ||
            prevProps.utmSelections.utmId !== this.props.utmSelections.utmId ||
            prevProps.utmSelections.utmSource !== this.props.utmSelections.utmSource ||
            prevProps.utmSelections.utmMedium !== this.props.utmSelections.utmMedium ||
            prevProps.utmSelections.utmName !== this.props.utmSelections.utmName ||
            prevProps.utmSelections.utmContent !== this.props.utmSelections.utmContent ||
            prevProps.utmSelections.utmTerm !== this.props.utmSelections.utmTerm

        ) {
            await this.getClicks();
        }
    };

    getDateFromPropsOrDefault = (key) => {
        const dateFromProps = this.props[key]
            ? DateTime.fromISO(this.props[key]) // Handles direct Luxon objects or ISO strings
            : this.props.location?.state?.[key]
                ? DateTime.fromISO(this.props.location.state[key]) // Handles passed state from history.push
                : null;

        return dateFromProps?.isValid ? dateFromProps : DateTime.utc(); // Fallback to UTC if invalid
    };

    setUserFromPropsOrFetch = async (userName) => {
        try {
            var users = await this.fetchUsers(userName);
            if (!!(users) && users.length > 0 && !!(users[0])) {
                const user = users[0]

                const userArray = [...user]
                await this.setUserSelected(userArray);
                this.getClicks();
            }
        } catch (error) {
            console.error("Error fetching user:", error);
        }
        // Clear state after first read
        if (this.props.history) {
            this.props.history.replace({
                ...this.props.location,
                state: {}
            });
        }
    };

    handleStartDateChange = (event) => {
        const startDateRaw = event.target.value;
        if (startDateRaw.length === 0) return;

        const startDate = DateTime.fromISO(startDateRaw).toUTC().startOf('day');
        if (startDate.isValid) {
            if (this.state.hourly) {
                this.setState({ startDate, endDate: startDate });
            } else {
                this.setState({ startDate });
            }
        } else {
            console.error("Invalid start date entered:", startDateRaw);
        }
    };

    handleEndDateChange = (event) => {
        const endDateRaw = event.target.value;
        if (endDateRaw.length === 0) return;

        const endDate = DateTime.fromISO(endDateRaw).toUTC().endOf('day');
        if (endDate.isValid) {
            this.setState({ endDate });
        } else {
            console.error("Invalid end date entered:", endDateRaw);
        }
    };

    handleWeekToDate = () => {
        const startDate = DateTime.utc().minus({ weeks: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    handleMonthToDate = () => {
        const startDate = DateTime.utc().minus({ months: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    handleYearToDate = () => {
        const startDate = DateTime.utc().minus({ years: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    handleHourlyChange = (event) => {
        const hourly = event?.target?.checked ?? false; // Safely get the checked value or default to false

        this.setState({ hourly, endDate: this.state.startDate, startHour: 0, endHour: 23 }, () => this.getClicks());
    };

    breadCrumbList = [{ link: '/Admin', text: 'Admin' }, { link: '/Admin/ProfileClicks', text: 'Creator Clicks' }];


    getClicks = async () => {
        let url = `api/Merchant/GetTrackingRegister`;
        const { startDate, endDate } = this.state;
        const { utmId, utmSource, utmMedium, utmName, utmContent, utmTerm } = this.props.utmSelections;
        const userId = this.props.userId || -1;
        let now = DateTime.now();
        let offset = now.offset;

        if (startDate > endDate) {
            this.setState({ dateError: true });
            return;
        }

        if (startDate) {
            url += `?startDate=${startDate.toSQL({ includeOffset: false })}`;
        }

        if (endDate) {
            url += url.includes('?')
                ? `&endDate=${endDate.toSQL({ includeOffset: false })}`
                : `?endDate=${endDate.toSQL({ includeOffset: false })}`;
        }

        url += `&offset=${offset}&id=${userId}&utmId=${utmId}&utmSource=${utmSource}&utmMedium=${utmMedium}&utmName=${utmName}&utmContent=${utmContent}&utmTerm=${utmTerm}`;

        this.setState({ clicksLoading: true, clicks: [] });

        try {
            const clicks = await getRequest(url);

            this.setState({ clicks, clicksLoading: false });
        } catch (error) {
            console.error("Error fetching clicks:", error);
            this.setState({ clicks: [], clicksLoading: false });
        }
    };

    setUserSelected = (userSelected) => {
        if (userSelected != null) {
            this.setState(userSelected);
        }
    };

    handleStartHourChange = (event) => {
        this.setState({ startHour: event.target.value });
    };

    handleEndHourChange = (event) => {
        this.setState({ endHour: event.target.value });
    };

    fetchUsers = async (query) => {
        this.setState({ isLoading: true });
        let url = `/api/Account/GetUserSuggestionsByUsername?username=${query}`;

        let users = await getRequest(url);
        this.setState({ userOptions: users, isLoading: false });
        return users;
    }

    render() {
        const csvEscape = (v) => {
            if (v === null || v === undefined) return "";
            let s = String(v);
            if (s.includes('"')) s = s.replace(/"/g, '""');
            return /[",\n]/.test(s) ? `"${s}"` : s;
        };

        const { utmId, utmSource, utmMedium, utmName, utmContent, utmTerm } = this.props.utmSelections || {};

        const selectedUtmKeys = [
            utmId && { key: "utmId", header: "utm_id" },
            utmSource && { key: "utmSource", header: "utm_source" },
            utmMedium && { key: "utmMedium", header: "utm_medium" },
            utmName && { key: "utmName", header: "utm_name" },
            utmContent && { key: "utmContent", header: "utm_content" },
            utmTerm && { key: "utmTerm", header: "utm_term" },
        ].filter(Boolean);

        // Build the CSV in onDownload
        const onDownload = () => {
            const headers = [
                "Date",
                "Clicks",
                "Registrations",
                ...selectedUtmKeys.map(u => u.header)
            ];

            const lines = this.state.clicks.map(row => {
                const dateStr = row.date
                    ? convertToNumericMonthAndDayAndYearNoLocal(row.date, false).replace(",", "")
                    : "";
                const base = [
                    csvEscape(dateStr),
                    csvEscape(row.clicks ?? ""),
                    csvEscape(row.registrationCount ?? ""),
                ];
                const utms = selectedUtmKeys.map(u => csvEscape(row[u.key] ?? ""));
                return [...base, ...utms].join(",");
            });

            // Prepend UTF-8 BOM so Excel opens it cleanly
            return "\uFEFF" + [headers.map(csvEscape).join(","), ...lines].join("\n");
        };

        const columns = [
            {
                name: "date",
                label: "Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        if (!value) {
                            return "-";
                        }
                        try {
                            return convertToNumericMonthAndDayAndYearNoLocal(value, false).replace(',', '');
                        } catch (error) {
                            console.error("Invalid date encountered:", value, error);
                            return "-";
                        }
                    },
                },
            },
            {
                name: "clicks",
                label: "Clicks",
                options: {
                    filter: true,
                    sort: true,
                    display: true,
                },
            },
            {
                name: "registrationCount",
                label: "Registrations",
                options: {
                    filter: true,
                    sort: true,
                    display: true,
                },
            },
            {
                name: "utmId",
                label: "utm_id",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmId,
                },
            },
            {
                name: "utmSource",
                label: "utm_source",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmSource,
                },
            },
            {
                name: "utmMedium",
                label: "utm_medium",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmMedium,
                },
            },
            {
                name: "utmName",
                label: "utm_name",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmName,
                },
            },
            {
                name: "utmContent",
                label: "utm_content",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmContent,
                },
            },
            {
                name: "utmTerm",
                label: "utm_term",
                options: {
                    filter: true,
                    sort: true,
                    display: this.props.utmSelections?.utmTerm,
                },
            },
        ];

        return (
            <>
                <div className="position-relative" style={{ zIndex: 0 }}>
                    <section>
                        <div>
                            <div className="row">
                                <div className="col">
                                    <ThemeProvider theme={this.state.ProfileClicksTable.getTheme()}>
                                        <MUIDataTable
                                            title={
                                                <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                                    <p style={{ fontSize: '22px', marginTop: "20px" }}>Refer A Creator UTM Tracking</p>
                                                    <p style={{ fontSize: '14px', marginBottom: "0" }}>Lookup Refer A Creator link tracking by UTM and date</p>
                                                </div>
                                            }
                                            data={this.state.clicks}
                                            columns={columns}
                                            options={{
                                                ...this.state.ProfileClicksTable.options,
                                                selectableRows: 'none',
                                                download: true,
                                                downloadOptions: {
                                                    filename: "profile-utm-tracking.csv",
                                                    separator: ",",
                                                    // useDisplayedColumnsOnly doesn't matter since we override with onDownload
                                                },
                                                onDownload,
                                                textLabels: {
                                                    body: { noMatch: this.state.clicksLoading ? "LOADING..." : "No data available" }
                                                }
                                            }}
                                            ref={this.tableRef}
                                        />
                                    </ThemeProvider>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default AnalyticsTrackingRegister;
